import * as Types from '@xing-com/crate-common-graphql-types';

type colorsType = {
  [key in Types.VitaDocumentThemeColor]: {
    primary: string;
    secondary: string;
    text: string;
    textHeader: string;
    textOnPrimary: string;
    textOnSecondary: string;
    translation?: string;
  };
};

export const COLORS: colorsType = {
  [Types.VitaDocumentThemeColor.DarkBlue]: {
    primary: '#202E4B',
    secondary: '#304F6D',
    text: '#000',
    textHeader: '#fff',
    textOnPrimary: '#fff',
    textOnSecondary: '#fff',
    translation: 'CRATE_LEBENSLAUF_COLOR_DARKBLUE',
  },
  [Types.VitaDocumentThemeColor.LightBlue]: {
    primary: '#1264A0',
    secondary: '#E4F0FA',
    text: '#000',
    textHeader: '#8AC0E8',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_BLUE',
  },
  [Types.VitaDocumentThemeColor.DarkGreen]: {
    primary: '#01756E',
    secondary: '#E6F1F1',
    text: '#000',
    textHeader: '#029289',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_MINT',
  },
  [Types.VitaDocumentThemeColor.Purple]: {
    primary: '#4C5379',
    secondary: '#EDEFFF',
    text: '#000',
    textHeader: '#9FA6CD',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_VIOLET',
  },
  [Types.VitaDocumentThemeColor.Pink]: {
    primary: '#76283D',
    secondary: '#FFE4EB',
    text: '#000',
    textHeader: '#E4859F',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_PINK',
  },
  [Types.VitaDocumentThemeColor.Orange]: {
    primary: '#A32700',
    secondary: '#F9DCD3',
    text: '#000',
    textHeader: '#F37046',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_ORANGE',
  },
  [Types.VitaDocumentThemeColor.LightSea]: {
    primary: '#0A5A5B',
    secondary: '#CEF1F2',
    text: '#000',
    textHeader: '#44C5C7',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_AQUAMARINE',
  },
  [Types.VitaDocumentThemeColor.LightGreen]: {
    primary: '#276726',
    secondary: '#DCECDC',
    text: '#000',
    textHeader: '#77B576',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_GREEN',
  },
  [Types.VitaDocumentThemeColor.Grey]: {
    primary: '#5A636D',
    secondary: '#E3E3E3',
    text: '#000',
    textHeader: '#8A95A0',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_GRAY',
  },
  [Types.VitaDocumentThemeColor.Brown]: {
    primary: '#4D3C10',
    secondary: '#C6C1A6',
    text: '#000',
    textHeader: '#494C4F',
    textOnPrimary: '#fff',
    textOnSecondary: '#000',
    translation: 'CRATE_LEBENSLAUF_COLOR_BROWN',
  },
};
